
// columnItems
// tableProps
const DyCouponTable = {
  columnItems: [
    {
      label: '门店编号',
      prop: 'fAgentId'
    }, {
      label: '门店名称',
      prop: 'fAgentId'
    }, {
      label: '商户编号',
      slotName: 'fAgentId'
    }, {
      label: '上级机构名称',
      prop: 'fAgentId'
    }, {
      label: '审核状态',
      slotName: 'fAgentId'
    }, {
      label: '交易状态',
      slotName: 'fAgentId'
    }, {
      label: '结算状态',
      slotName: 'fAgentId'
    }, {
      label: '信息是否与总部一致',
      slotName: 'fAgentId'
    }, {
      label: '刷卡权限',
      slotName: 'fAgentId'
    }, {
      label: '是否开通D0权限',
      slotName: 'fAgentId'
    }, {
      custom: true,
      slotName: 'operate',
      label: '操作',
      // width: '300',
      align: 'right'
    }
  ],
  tableProps: {
    style: {
      width: '100%'
    }
    // maxHeight: 300
  }
}
export const tableData = {
  DyCouponTable
}
